// extracted by mini-css-extract-plugin
export default {"report-category-display-section":"ReportCategoryDisplaySection_report-category-display-section__+FuZ-"};